import { awardImages } from '../assets/awards'

export interface Award {
  id: number
  title: string
  year: string
  url?: string
  image?: string
}

export const awards: Award[] = [
  // 2026
  {
    id: 17,
    title: 'Grand Prize — Huawei ICT Competition 2025–2026 Global Final, Computing Track, Shenzhen (Team Instructor & Mentor)',
    year: '2026',
    image: awardImages['grand.jpg'],
  },
  // 2025
  {
    id: 1,
    title: 'First Prize — Huawei ICT Competition 2024–2025 Global Final, Computing Track, Shenzhen',
    year: '2025',
    image: awardImages['huawei-ict-2025.webp'],
    url: 'https://e.huawei.com/en/talent/news/#/details?consultationId=4971',
  },
  {
    id: 2,
    title: 'Published at IEEE — DataForge: AI-Driven Data Warehouse Schema Generator',
    year: '2025',
    image: awardImages['ieee.webp'],
    url: 'https://ieeexplore.ieee.org/document/11313182',
  },
  {
    id: 7,
    title: 'Huawei Success Story — Official Recognition',
    year: '2025',
    image: awardImages['huaweistory.webp'],
    url: 'https://www.facebook.com/share/v/14W5xgXzuPJ/',
  },
  // 2024
  {
    id: 16,
    title: 'Graduated with Honours — FCIS, Ain Shams University · Graduation Project A+',
    year: '2024',
  },
  {
    id: 8,
    title: 'Journey of a Huawei Ambassador in Egypt — Documentary',
    year: '2024',
    image: awardImages['huawei-ambassador-egypt.webp'],
    url: 'https://www.youtube.com/watch?v=DaRmknbnevE&feature=youtu.be',
  },
  {
    id: 9,
    title: 'Speaker — 12th International Ain Shams Engineering Conference',
    year: '2024',
    image: awardImages['icicis.webp'],
  },
  {
    id: 10,
    title: 'Featured in Magazine 30.30 Egypt',
    year: '2024',
    image: awardImages['magazine.webp'],
    url: 'https://www.facebook.com/photo?fbid=246274724713359&set=a.152506260756873',
  },
  {
    id: 11,
    title: 'Humans of FCIS — Ain Shams University Documentary',
    year: '2024',
    image: awardImages['fcis-documentary.webp'],
    url: 'https://www.facebook.com/Humans.FCIS/photos/a.1384881151568385/4943844815671983/',
  },
  // 2023
  {
    id: 3,
    title: 'Represented Egypt at MWC Barcelona',
    year: '2023',
  },
  {
    id: 4,
    title: '1st Place — Huawei Seeds for the Future',
    year: '2023',
    image: awardImages['seeds.webp'],
  },
  {
    id: 14,
    title: 'Huawei ICT Competition — Ministry of Education TV Feature',
    year: '2023',
    image: awardImages['huawei-ict-2022.webp'],
    url: 'https://www.youtube.com/watch?v=mM1Lu4qVHq4',
  },
  // 2022–2023
  {
    id: 5,
    title: 'Huawei Annual Ambassador Award',
    year: '2022 & 2023',
    image: awardImages['huawei-annual-ambassador.webp'],
  },
  // 2022
  {
    id: 6,
    title: 'Top 50 Inspiring Coders in the Arab World — Dubai Future Foundation',
    year: '2022',
    url: 'https://www.dubaifuture.ae/omac-stories/abdelrahman-abdelmageed',
    image: awardImages['omac.webp'],
  },
  {
    id: 12,
    title: 'Egypt Future Work is Digital — FWD Success Story',
    year: '2022',
    image: awardImages['FWD.webp'],
    url: 'https://www.youtube.com/watch?v=Vh1GtONdlwM&feature=youtu.be',
  },
  {
    id: 13,
    title: 'Egyptian Youth in Freelance — ElMehwar TV Feature',
    year: '2022',
    image: awardImages['elmehwar.webp'],
    url: 'https://www.youtube.com/watch?v=4OmA36c48r0',
  },
  // 2019
  {
    id: 15,
    title: '2nd Place — Z Dare Entrepreneurship Competition',
    year: '2019',
    image: awardImages['zdare.webp'],
  },
]
